import { useState } from 'react';
import copy from 'copy-to-clipboard';
import { markdownToPlainText } from '@shared/utils';
import IconButton from '@/components/chat-history/IconButton';
import Feedback from './Feedback';
import { Dropdown } from 'antd';
import Other from '@/common/helper/other';
import wsStore from '../store';

function ActionBar(props) {
  const store = wsStore.currentStore;
  const { className, renewable, answer, onRenew, msg_id, prompt, messageItem } =
    props;
  const [show, setshow] = useState(false);
  const deleteBtnClick = () => {
    store.log({
      action : "click",
      arrt : "aibot_plugin_sidebar_dele",
      message_id : messageItem.msg_id,
      role_id : messageItem.role_id,
    });
    setshow(false);
    Other.confirm({
      icon: null,
      closable: true,
      title: '确认删除对话',
      className: 'message-delete-confirm-modal',
      onOk: () => {
        store.deleteMessage(msg_id).then(code => {
          if (code == 0) {
            Other.toast('消息删除成功', "success");
          } else {
            Other.toast('消息删除失败', "error");
          }
        });
      },
    });
  };
  const dropList = () => {
    return (
      <div
        className="w-[168px] px-[8px] py-[8px] bg-white rounded-[16px] flex flex-col gap-[4px]"
        style={{ boxShadow: '0px 0px 8px 0px rgba(0,0,0,0.1)' }}
      >
        <div
          className="w-full h-[40px] rounded-[12px] font-bold text-[14px] text-[#FF5959] left-[8px] flex items-center gap-[8px] cursor-pointer bg-white hover:bg-[#FF5959] hover:bg-opacity-10 pl-[6px]"
          onClick={() => {
            deleteBtnClick();
          }}
        >
          <IconButton
            icon="delete"
            size={20}
            className="!opacity-100 !p-0 !bg-none"
          ></IconButton>
          删除
        </div>
      </div>
    );
  };

  return (
    <div
      className={[
        'flex justify-between items-center',
        className,
        show ? '!visible' : '',
      ]}
    >
      <section className="flex items-center gap-[8px]">
        <IconButton
          className="px-[8px]"
          icon="copy"
          size={16}
          onClick={() => {
            const plainText = markdownToPlainText(answer);
            const copied = copy(plainText);
            copied && Other.toast('复制成功', "success");
            store.log({
              action : "click",
              arrt : "aibot_plugin_sidebar_copy",
              message_id : messageItem.msg_id,
              role_id : messageItem.role_id,
            });
          }}
        >
          复制
        </IconButton>

        {renewable && (
          <IconButton
            className="px-[8px]"
            icon="sync"
            size={16}
            onClick={() => {
              onRenew?.();
              store.log({
                action : "click",
                arrt : "aibot_plugin_sidebar_re_generate",
                message_id : messageItem.msg_id,
                role_id : messageItem.role_id,
              });
              store.log({
                action : "act",
                arrt : "new_chat",
                ext : "re_generate",
              });
            }}
          >
            再试一次
          </IconButton>
        )}

        <Dropdown
          dropdownRender={() => dropList()}
          trigger="click"
          position="tl"
          open={show}
          onOpenChange={visible => setshow(visible)}
        >
          <IconButton
            icon="more"
            iconClassName='text-[rgb(0,0,0,.5)]'
            size={16}
            onClick={() => {
              if(!show){
                store.log({
                  action : "click",
                  arrt : "aibot_plugin_sidebar_more",
                  message_id : messageItem.msg_id,
                  role_id : messageItem.role_id,
                });
              }
            }}
          />
        </Dropdown>
      </section>

      <Feedback {...{ msg_id, prompt, messageItem }} />
    </div>
  );
}

export default ActionBar;
